$('.js-faq-ques').click(function () {
  $(this).toggleClass('open')
  $(this).next('.js-faq-ans').slideToggle()
})
